import React from "react"
const { ThemeProvider } = require("styled-components")

export default ({ children }) => (
  <ThemeProvider
    theme={{
      heading: '"Playfair Display", serif',
      body:
        '"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
      md: "50rem",
      lg: "70rem",
      gray: "#5c5c5c",
      lightGray: "#A8A8A8",
      mint: "#2FB998",
      red: "#E53E51",
    }}
  >
    {children}
  </ThemeProvider>
)
